import Api from "@/services/Api";

export default {
  sendMail (params) {
    return Api().post("/send-mail", params, {
      headers: { "x-access-token": localStorage.getItem("usertoken") }
    });
  },
  contact (params) {
    return Api().post("/contact", params);
  }
};
